import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QSetGeneratorResultsHeader } from '@exam-management/qset-generate-result';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QSetGeneratorResultsLayout() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QSET.CREATE]}>
      <Box
        sx={{
          minHeight: '100dvh',
        }}
      >
        <QSetGeneratorResultsHeader />
        <Outlet />
      </Box>
    </PermissionGuard>
  );
}
